import { object, string, number } from "yup";

export const bodyTempSchema = object({
    temperature: number()
        .typeError("Body Temperature level must be a number")
        .required("Temperature is required")
        .when('temperature_unit', ([temperatureUnit]) => {
            const c = temperatureUnit === '1'
            const minMessage = `Temperature level in ${c ? 'celsius' : 'fahrenheit'} must be greater than or equal to ${c ? 20 : 68}`
            const maxMessage = `Temperature level in ${c ? 'celsius' : 'fahrenheit'} must be less than or equal to ${c ? 45 : 113}`
            const logic = (message, {value}) => {
                const isEnterF = c && value >= 68 && value <= 113
                const isEnterC = !c && value >= 20 && value <= 45
                const chooseScale = isEnterF ? 'Fahrenheit' : 'Celsius'
                const appendMessage = isEnterC || isEnterF ? `, if your entered value is in ${chooseScale} then please select scale as ${chooseScale}` : ''
                return message + appendMessage
            }
            return number()
                .min(c ? 20 : 68, logic.bind(this, minMessage))
                .max(c ? 45 : 113, logic.bind(this, maxMessage))
        }),
    temperature_unit: string().required("Temperature unit is required")
});